<flowaccount-google-workspace-banner></flowaccount-google-workspace-banner>

<flowaccount-google-workspace-start-business></flowaccount-google-workspace-start-business>

<flowaccount-google-workspace-complete-solutions></flowaccount-google-workspace-complete-solutions>

<flowaccount-content-call-to-action-squidex
  [contentCTA]="'GOOGLE_WORKSPACE.CTA.HEADING'"
  [contentTextLink]="'GOOGLE_WORKSPACE.CTA.BTN'"
  [contentScully]="'CONTENT_CTA_GOOGLE_WORKSPACE'"
  [styleClass]="'google-workspace'"
  [isGoogleWorkspace]="true"
>
</flowaccount-content-call-to-action-squidex>

<flowaccount-google-workspace-3-step></flowaccount-google-workspace-3-step>

<flowaccount-google-workspace-productivity></flowaccount-google-workspace-productivity>

<flowaccount-faq-accordion-squidex
  [contentSquidex]="'google-workspace-faq'"
  [contentScully]="'google-workspace-faq-key'"
></flowaccount-faq-accordion-squidex>

<flowaccount-blog-swiper-squidex
  [customHeader]="customHeader"
  [contentSquidex]="'google-workspace-blog'"
  [contentScully]="'google-workspace-blog-key'"
></flowaccount-blog-swiper-squidex>

<flowaccount-google-workspace-service></flowaccount-google-workspace-service>
